module.exports = {
  address: "0x4c2d0e86bb7e976b8f26fcc3c0ce479b53158c3e",
  collection: "https://opensea.io/collection/ogenerator",
};
